/* eslint-disable eqeqeq */

import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import './LoanOfferComparison.scss';
import { PaymentMethodOptions, ReferenceRateBaseOptions } from "constants/Constants";
import 'moment/locale/fi';


const LoanOfferComparisonTextarea = (props:any) => {
    return (
        <>
            {
                (props?.printShow || props?.showbtn === '0')? <div {...props}>{props.text}</div> : <textarea {...props}>{props.text}</textarea>
            }
        </>
    );
};
export default LoanOfferComparisonTextarea;